import React, { useEffect } from "react";
import {
  Grid,
  Container,
  Heading,
  VStack,
  HStack,
  Avatar,
  Text,
  Flex,
  Box,
} from "@chakra-ui/react";
import Layout from "../../../components/student/Layout/layout";
import { Link, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getAllStudentChaptersRequest } from "../../../modules/students-modules/chapters/Actions";
import { withTranslation } from "react-i18next";
import { getSectionRequest } from "../../../modules/students-modules/sections/Actions";
const HomeworkChaptersList = ({ t }) => {
  const baseUrl = "https://asquera.com/asquera";

  const { id } = useParams();

  const section = useSelector((state) => state.sections.section);
  const isLoading = useSelector((state) => state.sections.isLoading);

  const dispatch = useDispatch();
  useEffect(() => {
    if (id) dispatch(getSectionRequest(id));
  }, [id]);
  return (
    <Layout color="main_1" bg="white" isLoading={isLoading}>
      <Container maxW="container.2xl" h="100%" my="100px" mb="165px" w="100%">
        <VStack spacing={8} h="100%" w="100%" alignItems="flex-start">
          <Heading as="h3" color="main_1" textAlign="center" w="100%">
            {t("homeworks")}
          </Heading>
          <Grid
            templateColumns={{ base: "repeat(1, 1fr)", md: "repeat(3, 1fr)" }}
            gap={6}
            w="100%"
          >
            {section?.map((chapter, idx) => {
              return (
                <Link
                  to={`/homework/${chapter?.id}?name=${chapter?.name}`}
                  key={idx}
                >
                  <Flex
                    flexDirection={"row"}
                    borderRadius="10px"
                    bg="#ededed"
                    gap={2}
                    p="10px"
                    cursor="pointer"
                  >
                    <Avatar
                      name={chapter?.name}
                      src={baseUrl + "/" + chapter?.logo}
                      borderRadius="8px"
                      size="lg"
                      background="transparent"
                    />
                    <Box>
                      <Text fontWeight="bold" fontSize="20px">
                        {chapter?.name}
                      </Text>
                    </Box>
                  </Flex>
                </Link>
              );
            })}
          </Grid>
        </VStack>
      </Container>
    </Layout>
  );
};

export default withTranslation()(HomeworkChaptersList);
